import { uniqBy } from 'lodash';
export var validationConfirmEditFormCleanFieldList = ['policy_number', 'policyholder', 'insurer_name', 'applicable_territories', 'amount', 'limit_per_occurrence', 'el_disease_each_employee', 'el_disease_policy_limit', 'statutory', 'start_date', 'end_date', 'business_activity', 'additional_insured', 'waiver_of_subrogation', 'organization_subsidiary'];
export var filterDuplicateRequirementCoverList = function filterDuplicateRequirementCoverList() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return uniqBy(list, function (item) {
    var _item$displayed_data;

    return (_item$displayed_data = item.displayed_data) === null || _item$displayed_data === void 0 ? void 0 : _item$displayed_data.cover_slug;
  });
};